// extracted by mini-css-extract-plugin
export default {"emails__editor":"emails_emails__editor__peGas"};